import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.css']
})
export class ImagePreviewComponent implements OnInit {
  @Input() image;
  @Input() isDownlaodTrue :boolean = false;
  @Input() downloadName :boolean = false;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }
  downloadImage() {
  const link = document.createElement('a');
  link.href = this.image;
  link.download = `${this.downloadName}.jpg`; // Change to .png if needed
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

}